import { render, staticRenderFns } from "./NextcloudFileIcon.vue?vue&type=template&id=fb62656a&scoped=true&"
import script from "./NextcloudFileIcon.vue?vue&type=script&lang=js&"
export * from "./NextcloudFileIcon.vue?vue&type=script&lang=js&"
import style0 from "./NextcloudFileIcon.vue?vue&type=style&index=0&id=fb62656a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb62656a",
  null
  
)

export default component.exports